import request from '@/utils/request';
import './index.less';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { useEffect, useState } from 'react';
import { getLocale, useIntl } from 'umi';
import { Toast } from 'antd-mobile';
import { getLocaleText } from '@/utils/utils';

// import Verify from './Verify';

//确认弹窗
const SureEmail = (props: any) => {
  const { email, close, setEmailVisble } = props;
  const intl = useIntl();

  // 关闭验证码弹窗
  const [time, setTime] = useState(10);
  useEffect(() => {
    let timer = setInterval(() => {
      if (time === 0) {
        clearInterval(timer);
      } else {
        setTime(time - 1);
      }
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [time]);

  const addEmail = async () => {
    const Url = `${process.env.BMSUrl}bms/user/login/changeUserInfo`;
    const res = await request.post(Url, {
      data: {
        lang: `${getLocale().replace(/-/gi, '_')}`,
        userId: localStorage.getItem('userId'),
        userToken: localStorage.getItem('userToken'),
        email: email,
        version: 1,
        platformCode: `${process.env.BMSsiteId}`,
      },
    });
    if (res.code === 200) {
      Toast.info(
        intl.formatMessage({
          id: 'mytv.page.emailBindingSuccess',
        }),
      );
      setEmailVisble(false);
      localStorage.setItem('ctmEmail', email);
    } else {
      Toast.info(res?.mes);
    }
  };

  return (
    <div>
      <Dialog
        className="sure"
        open={true}
        // title='首次觀看myTV內容需添加Email賬號'
        // onClose={handleClose}
        aria-labelledby="form-dialog-title"
        disableBackdropClick={true}
      >
        <div className="content">
          {' '}
          <DialogContent>
            <DialogContentText>
              {getLocaleText('mytv.page.confirmEmailAddress')}
            </DialogContentText>
            <div className="">
              <span className="text1">
                {getLocaleText('mytv.page.enterEmailAddress')}
              </span>
              <span className="text2">{email}</span>
            </div>
            <div className="text">{getLocaleText('mytv.page.emailNotice')}</div>
          </DialogContent>
          <DialogActions>
            {time === 0 ? (
              <Button
                onClick={() => {
                  addEmail();
                }}
                className="sure_btn"
                color="primary"
              >
                {getLocaleText('mytv.page.confirm')}
              </Button>
            ) : (
              <Button onClick={() => {}} color="primary">
                {` ${time} ${getLocaleText('mytv.page.confirmLater')} `}
              </Button>
            )}

            <Button
              className="cancel"
              onClick={() => {
                close();
              }}
              color="primary"
            >
              {getLocaleText('mytv.page.cancel')}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
};

export default SureEmail;
